export default __webpack_public_path__ + "static/media/14-3D-(5-3).974ba8be.jpg";